import { render, staticRenderFns } from "./OrderShipperInfo.vue?vue&type=template&id=576fef32&scoped=true&"
import script from "./OrderShipperInfo.vue?vue&type=script&lang=js&"
export * from "./OrderShipperInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderShipperInfo.vue?vue&type=style&index=0&id=576fef32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576fef32",
  null
  
)

export default component.exports